export const toggleCompanyForm = (value) => {
  return {
    type: "TOGGLE_COMPANY_FORM",
    payload: value,
  };
};
export const toggleCompanyFormYear1 = (value) => {
  return {
    type: "TOGGLE_COMPANY_FORM_YEAR1",
    payload: value,
  };
};
export const toggleCompanyFormYear2 = (value) => {
  return {
    type: "TOGGLE_COMPANY_FORM_YEAR2",
    payload: value,
  };
};
export const toggleCompanyFormYear3 = (value) => {
  return {
    type: "TOGGLE_COMPANY_FORM_YEAR3",
    payload: value,
  };
};
